import React from "react";
import { useT } from "@/lib/LanguageContext";
import { cn } from "../../../lib/utils";
import { STATE_CLASSES } from "../theme/states";

const PILL = {
  normal: STATE_CLASSES.positive,
  ending: STATE_CLASSES.warning,
  finished: STATE_CLASSES.danger,
};
const PLAIN = {
  normal: "text-eh-ink",
  ending: "text-amber-800",
  finished: "text-rose-800",
};

/**
 * A pack balance, everywhere a client appears (spec Screen 7 "Balance display"):
 * "7 of 10 used" (sage) · "8 of 10 used · 2 left" (amber, at 2 left) · "10 of 10 used"
 * (red, at 0). The colour state is the SERVER's (`state normal|ending|finished`), so the
 * threshold is the practice's setting, not a constant guessed here.
 *
 * `variant="session"` prints the Today card form ("Session 9 of 10") from
 * `{session_number, sessions_total}`; `size="lg"` prints the summary-strip form, bold
 * text without a pill.
 */
export default function PackBalanceBadge({ pack, variant = "balance", size = "sm", className, testId }) {
  const t = useT("crm");
  if (!pack) return null;
  if (variant === "session") {
    return (
      <span data-testid={testId} className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap", STATE_CLASSES.positive, className)}>
        {t("today.sessionOf", { n: pack.session_number, total: pack.sessions_total })}
      </span>
    );
  }
  const used = pack.sessions_used;
  const total = pack.sessions_total;
  const left = Math.max(0, total - used);
  const state = PILL[pack.state] ? pack.state : "normal";
  const text = state === "ending"
    ? t("pack.usedLeft", { used, total, left })
    : t("pack.used", { used, total });
  if (size === "lg") {
    return <span data-testid={testId} data-state={state} className={cn("text-lg font-semibold", PLAIN[state], className)}>{text}</span>;
  }
  return (
    <span data-testid={testId} data-state={state}
      className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap", PILL[state], className)}>
      {text}
    </span>
  );
}
